// import React, { useState } from "react";
// import styles from "../../assets/scss/Plans/Plans.module.scss";
// import PopupWrapper from "../../Components/Common/PopupWrapper";
// import AddPlans from "./AddPlans";

// const Plans = () => {
//     const [openPopup, setOpenPopup] = useState(false);
//     const [selectedPlan, setSelectedPlan] = useState(null);

//     const handleOpen = () => {
//         setSelectedPlan(null); // For Add
//         setOpenPopup(true);
//     };

//     const handleEdit = (plan) => {
//         setSelectedPlan(plan); // For Edit
//         setOpenPopup(true);
//     };

//     const handleClose = () => {
//         setOpenPopup(false);
//         setSelectedPlan(null);
//     };

//     return (
//         <>
//             <div className={styles.plansWrapper}>
//                 <div className={styles.header}>
//                     <h1 className={styles.heading}>Plans</h1>
//                     <div>
//                         <button
//                             className={styles.addBtn}
//                             onClick={handleOpen}
//                         >
//                             Create New Plan
//                         </button>
//                     </div>
//                 </div>

//                 <div className={styles.cardsContainer}>

//                     {/* Spectator */}
//                     <div
//                         className={styles.card}
//                         onClick={() =>
//                             handleEdit({
//                                 planName: "Spectator",
//                                 durationTime: 0,
//                                 durationType: "Months",
//                                 price: 0,
//                                 isFree: true,
//                             })
//                         }
//                     >
//                         <h2>Spectator</h2>
//                         <h3 className={styles.price}>Free Plan</h3>

//                         <ul>
//                             <li>This plan allows an individual to register and update profile.</li>
//                             <li>Cannot post transfer requests.</li>
//                             <li>Can only respond if other club initiates.</li>
//                         </ul>

//                         <button className={styles.addBtn}>
//                             Edit Plan
//                         </button>
//                     </div>

//                     {/* Professional */}
//                     <div
//                         className={styles.card}
//                         onClick={() =>
//                             handleEdit({
//                                 planName: "Professional",
//                                 durationTime: 1,
//                                 durationType: "Months",
//                                 price: 29,
//                                 isFree: false,
//                             })
//                         }
//                     >
//                         <h2>Professional</h2>
//                         <h3 className={styles.price}>£29 / Month</h3>

//                         <ul>
//                             <li>Access to club features.</li>
//                             <li>Limited number of players.</li>
//                             <li>Limited number of requests annually.</li>
//                         </ul>

//                         <button className={styles.addBtn}>
//                             Edit Plan
//                         </button>
//                     </div>

//                     {/* Enhanced */}
//                     <div
//                         className={styles.card}
//                         onClick={() =>
//                             handleEdit({
//                                 planName: "Enhanced",
//                                 durationTime: 1,
//                                 durationType: "Months",
//                                 price: 49,
//                                 isFree: false,
//                             })
//                         }
//                     >
//                         <h2>Enhanced</h2>
//                         <h3 className={styles.price}>£49 / Month</h3>

//                         <ul>
//                             <li>Full access plan.</li>
//                             <li>No restriction on squad size.</li>
//                             <li>Unlimited requests.</li>
//                         </ul>

//                         <button className={styles.addBtn}>
//                             Edit Plan
//                         </button>
//                     </div>

//                 </div>
//             </div>

//             {/* Popup */}
//             {openPopup && (
//                 <PopupWrapper
//                     title={selectedPlan ? "Update Plan" : "Create New Plan"}
//                     onClose={handleClose}
//                 >
//                     <AddPlans
//                         onClose={handleClose}
//                         editData={selectedPlan}
//                     />
//                 </PopupWrapper>
//             )}
//         </>
//     );
// };

// export default Plans;

import React, { useState } from "react";
import styles from "../../assets/scss/Plans/Plans.module.scss";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import AddPlans from "./AddPlans";
import { useDeletePlanMutation, useGetPlansQuery } from "../../slices/admin/admin";

const Plans = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const { data, isLoading } = useGetPlansQuery({
        offset: 1,
        limit: 10,
    });

    const [deletePlan] = useDeletePlanMutation();

    const handleOpen = () => {
        setSelectedPlan(null);
        setOpenPopup(true);
    };

    const handleEdit = (plan) => {
        setSelectedPlan(plan);
        setOpenPopup(true);
    };

    const handleDelete = async (id) => {
        await deletePlan(id);
    };

    const handleClose = () => {
        setOpenPopup(false);
        setSelectedPlan(null);
    };

    return (
        <>
            <div className={styles.plansWrapper}>
                <div className={styles.header}>
                    <h1 className={styles.heading}>Plans</h1>
                    <button className={styles.addBtn} onClick={handleOpen}>
                        Create New Plan
                    </button>
                </div>

                <div className={styles.cardsContainer}>
                    {isLoading && <p>Loading...</p>}

                    {data?.data?.map((plan) => (
                        <div
                            key={plan._id}
                            className={styles.card}
                        >
                            <h2>{plan.planName}</h2>

                            <h3 className={styles.price}>
                                {plan.isFree
                                    ? "Free Plan"
                                    : `₹${plan.price} / ${plan.duration} ${plan.durationType}`}
                            </h3>

                            <p>{plan.description}</p>

                            {/* Buttons Section */}
                            <div style={{ display: "flex", gap: "10px" }}>

                                {/* ✅ UPDATE BUTTON */}
                                <button
                                    className={styles.addBtn}
                                    onClick={() => handleEdit(plan)}
                                >
                                    Update Plan
                                </button>

                                {/* ✅ DELETE BUTTON */}
                                <button
                                    className={styles.addBtn}
                                    onClick={() => handleDelete(plan._id)}
                                >
                                    Delete Plan
                                </button>

                            </div>
                        </div>
                    ))}

                </div>
            </div>

            {openPopup && (
                <PopupWrapper
                    title={selectedPlan ? "Update Plan" : "Create New Plan"}
                    onClose={handleClose}
                >
                    <AddPlans onClose={handleClose} editData={selectedPlan} />
                </PopupWrapper>
            )}
        </>
    );
};

export default Plans;

